"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketplaceConstants = void 0;
exports.marketplaceConstants = {
    USA: {
        marketplaceId: "CBT",
        authEndpoint: "global-selling.mercadolibre.com",
        clientIdVar: "MERCADO_LIBRE_CBT_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CBT_CLIENT_SECRET",
    },
    ARG: {
        marketplaceId: "MLA",
        authEndpoint: "auth.mercadolibre.com.ar",
        retailHost: "www.mercadolibre.com.ar",
        clientIdVar: "MERCADO_LIBRE_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CLIENT_SECRET",
    },
    BRA: {
        marketplaceId: "MLB",
        authEndpoint: "auth.mercadolivre.com.br",
        retailHost: "www.mercadolivre.com.br",
        clientIdVar: "MERCADO_LIBRE_MLB_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_MLB_CLIENT_SECRET",
    },
    CHL: {
        marketplaceId: "MLC",
        authEndpoint: "auth.mercadolibre.cl",
        retailHost: "www.mercadolibre.cl",
        clientIdVar: "MERCADO_LIBRE_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CLIENT_SECRET",
    },
    COL: {
        marketplaceId: "MCO",
        authEndpoint: "auth.mercadolibre.com.co",
        retailHost: "www.mercadolibre.com.co",
        clientIdVar: "MERCADO_LIBRE_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CLIENT_SECRET",
    },
    MEX: {
        marketplaceId: "MLM",
        authEndpoint: "auth.mercadolibre.com.mx",
        retailHost: "www.mercadolibre.com.mx",
        clientIdVar: "MERCADO_LIBRE_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CLIENT_SECRET",
    },
    URY: {
        marketplaceId: "MLU",
        authEndpoint: "auth.mercadolibre.com.uy",
        retailHost: "www.mercadolibre.com.uy",
        clientIdVar: "MERCADO_LIBRE_CLIENT_ID",
        clientSecretVar: "MERCADO_LIBRE_CLIENT_SECRET",
    },
};
//# sourceMappingURL=marketplaceConstants.js.map